import { Edit as EditIcon } from "@mui/icons-material";
import { Alert, Box, Card, Grid, IconButton, Stack, Typography } from "@mui/material";
import { getStatus } from "src/utils/getStatus";
import type { LivestreamData } from "./types";

interface LivestreamCardProps {
	livestream: LivestreamData;
	onEdit: () => void;
}

export default function LivestreamCard({ livestream, onEdit }: LivestreamCardProps) {
	return (
		<Card sx={{ p: 3, mb: 3 }}>
			<Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
				<Typography variant="h5" sx={{ fontWeight: 600 }}>
					Livestream
				</Typography>

				<IconButton onClick={onEdit} color="primary" size="large">
					<EditIcon />
				</IconButton>
			</Stack>

			<Grid container spacing={3}>
				<Grid item xs={12} md={3}>
					<Box
						sx={{
							width: "100%",
							height: 200,
							backgroundColor: "#f5f5f5",
							borderRadius: 1,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							overflow: "hidden",
							border: "2px dashed #ddd",
						}}
					>
						{livestream.image_uri ? (
							<img
								src={livestream.image_uri}
								alt="Livestream thumbnail"
								style={{
									width: "100%",
									height: "100%",
									objectFit: "cover",
								}}
								onError={(e) => {
									const target = e.target as HTMLImageElement;
									target.style.display = "none";
									target.parentElement!.innerHTML =
										'<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; color: #999;"><svg width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M8.5,8.64L13.77,12L8.5,15.36V8.64M6.5,5V19L19.5,12" /></svg><span style="margin-top: 8px; font-size: 14px;">Помилка завантаження</span></div>';
								}}
							/>
						) : (
							<Stack alignItems="center" spacing={1}>
								<Box sx={{ color: "#ccc", fontSize: 48 }}>📺</Box>
								<Typography color="textSecondary" variant="caption">
									No image
								</Typography>
							</Stack>
						)}
					</Box>
				</Grid>
				<Grid item xs={12} md={9}>
					<Stack spacing={2}>
						<Typography variant="h6" sx={{ fontWeight: 600 }}>
							{livestream.title || "Untitled"}
						</Typography>
						<Typography variant="body2" color="textSecondary">
							{livestream.description || "No description"}
						</Typography>
						<Box>
							<Typography variant="caption" color="textSecondary" gutterBottom sx={{ display: "block" }}>
								Video URL:
							</Typography>
							<Typography
								variant="body2"
								color="primary"
								sx={{
									wordBreak: "break-all",
									textDecoration: livestream.video_uri ? "underline" : "none",
									cursor: livestream.video_uri ? "pointer" : "default",
									"&:hover": {
										color: livestream.video_uri ? "primary.dark" : "inherit",
									},
								}}
								onClick={() => {
									if (livestream.video_uri) {
										window.open(livestream.video_uri, "_blank");
									}
								}}
							>
								{livestream.video_uri || "No URL"}
							</Typography>
							<Alert severity={livestream.status === 1 ? "success" : "error"} sx={{ mt: 2 }}>
								{getStatus(livestream.status)}
							</Alert>
						</Box>
					</Stack>
				</Grid>
			</Grid>
		</Card>
	);
}
